import React from 'react';
import { useGlobalContext } from './context/GlobalContext';  // Importation correcte
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AppRouter from './router/AppRouter';
import CookieBanner from './components/common/CookieBanner';


const App = () => {
  const { store,cookieAccepted } = useGlobalContext();
  return (
    <div >
      {store.showCookieAcceptance && !cookieAccepted && (
        <CookieBanner />
      )}
      <Header
        logo={store.logo}
        siteUrl={store.site}
        languages={store.languages}
      />
      <AppRouter store={store} />
      {store && !store.exception && (
        <Footer
          layoutType={store.b2b2c ? 'b2b2c' : 'standard'}
          legalLinks={store.legalLinks}
        />
      )}
    </div>



  );
};

export default App;
